// Shared markdown → section splitter for the briefing web view and the PDF template.
// `index` is a sequential key (anchors, React keys); `label` is the number shown to the
// reader and follows the heading's own number ("## 0. Identitätsklärung" → "0"), so M&A
// briefings with a Sektion 0 keep the numbering that in-text cross-references use.

export interface ParsedSection {
  index: number;
  label: string;
  title: string;
  markdown: string;
}

export function parseBriefingSections(markdown: string, introTitle: string): ParsedSection[] {
  const sections: ParsedSection[] = [];
  // In a numbered briefing the unnumbered preamble must not take a number from a real section.
  const numbered = /^##\s+\d+[.)]/m.test(markdown);
  const parts = markdown.split(/^(?=## )/m);

  let index = 1;
  for (const part of parts) {
    const trimmed = part.trim();
    if (!trimmed) continue;

    const headingMatch = trimmed.match(/^##\s+(?:(\d+)[.)]\s*)?(.+)/);
    if (headingMatch) {
      const bodyStart = trimmed.indexOf('\n');
      sections.push({
        index,
        label: headingMatch[1] ?? String(index),
        title: headingMatch[2].trim(),
        markdown: bodyStart >= 0 ? trimmed.slice(bodyStart + 1).trim() : '',
      });
      index++;
    } else if (trimmed.length > 100) {
      // Preamble before the first ## heading
      sections.push({ index, label: numbered ? '•' : String(index), title: introTitle, markdown: trimmed });
      index++;
    }
  }

  return sections;
}
